/**
 * レイヤ種別を表すenum
 */
export enum RootLayerType {
  Travos = "交通量データ",
  Etc = "ETC2.0",
  Od = "OD",
  RoadStructures = "点検DB",
  Drm = "DRM-DB",
}

const enumKeys = Object.keys(RootLayerType);
const enumValues = Object.values(RootLayerType);

/**
 * レイヤ種別からenumのkey名を取得
 * @param RootLayerType レイヤ種別
 */
export const getRootLayerTypeKey = (rootLayerType: string) => {
  const index = enumValues.indexOf(rootLayerType as RootLayerType);
  if (index >= 0) {
    return enumKeys[index] as string;
  }
  return null;
};
